<template>
  <div>
    <vue-headful title="Credimóvil | Iniciar sesión"/>
    <menu-component v-bind:use-apply-now=isLogin></menu-component>

    <!-- Banner Area -->
    <section class="banner_area banner_area_8">
        <div class="container">
            <div class="col-12">
                <div class="row">
                    <div class="col-lg-8 col-md-7 col-sm-12">
                        <h2><span>Compra tu auto, </span>nosotros te apoyamos</h2>
                    </div>
                    <div class="col-lg-4 col-md-5 col-sm-12 form-login-gpi" v-if="loginOpen == true">
                        <div class="col-12 py-3">
                            <h3>Ingresa a la plataforma</h3>
                        </div>
                        <form class="from_main" method="post" id="phpcontactform" novalidate="novalidate">
                            <div class="col-lg-12 select_from">
                                <h6>Correo electrónico*</h6>
                                <input type="email" class="post_select" name="email" v-model="email">
                            </div>
                            <div class="col-lg-12 select_from">
                                <h6>Contraseña*</h6>
                                <input type="password" class="post_select" name="password" v-model="password">
                            </div>
                            <div class="col-lg-12">
                                <a href="javascript:void(0);" v-on:click="loginOpen = false; verificationStep = 1;">Olvidé mi contraseña</a>
                            </div>
                            <div class="col-12">
                                <div class="row">
                                    <div class="form-group col-6">
                                        <a href="/create-account" class="crear-cuenta theme_btn btn" id="js-contact-btn">Crear cuenta</a>
                                    </div>
                                    <div class="form-group col-6">
                                        <button class="theme_btn btn float-right" v-on:click="login()">Iniciar sesión</button>
                                        <!-- <div id="js-contact-result" data-success-msg="Form submitted successfully." data-error-msg="Messages Successfully"></div> -->
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="col-lg-4 col-md-5 col-sm-12 form-login-gpi" v-if="loginOpen == false && verificationStep == 1">
                        <div class="col-12 py-3">
                            <h3>Recuperar contraseña</h3>
                        </div>
                        <form class="from_main" method="post" id="phpcontactform" novalidate="novalidate">
                            <div class="col-lg-12 select_from">
                                <h6>Correo electrónico*</h6>
                                <input type="email" class="post_select" name="email" v-model="recoveryEmail">
                            </div>
                            <div class="col-lg-12 select_from">
                                <div class="alert alert-info">
                                    <strong>¿Haz olvidado tu contraseña?</strong><br>
                                    Para recibir tu código de acceso por correo electrónico, introduce la dirección
                                    de correo electrónico que proporcionaste durante el proceso de registro.
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="row">
                                    <div class="form-group col-6">
                                        <a class="crear-cuenta theme_btn btn" v-on:click="loginOpen = true; event.preventDefault();">Iniciar sesión</a>
                                    </div>
                                    <div class="form-group col-6">
                                        <button class="theme_btn btn float-right" v-on:click="sendRecoverPassword()">Enviar</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="col-lg-4 col-md-5 col-sm-12 form-login-gpi" v-if="loginOpen == false && verificationStep == 2">
                        <div class="col-12 py-3">
                            <h3>Recuperar contraseña</h3>
                        </div>
                        <form class="from_main" method="post" id="phpcontactform" novalidate="novalidate">
                            <div class="col-lg-12 select_from">
                                <h6>Código de verificación*</h6>
                                <input type="email" class="post_select" name="email" v-model="recoveryCode">
                            </div>
                            <div class="col-lg-12 select_from">
                                <div class="alert alert-info">
                                    Para recuperar tu contraseña ingresa el código que ha sido enviado a la dirección
                                    de correo electrónico que proporcionaste durante el proceso de registro.
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="row">
                                    <div class="form-group col-6">
                                        <a class="crear-cuenta theme_btn btn" v-on:click="loginOpen = true; event.preventDefault();">Iniciar sesión</a>
                                    </div>
                                    <div class="form-group col-6">
                                        <button class="theme_btn btn float-right" v-on:click="validateRecoveryCode()">Siguiente</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="col-lg-4 col-md-5 col-sm-12 form-login-gpi" v-if="loginOpen == false && verificationStep == 3">
                        <div class="col-12 py-3">
                            <h3>Recuperar contraseña</h3>
                        </div>
                        <form class="from_main" method="post" id="phpcontactform" novalidate="novalidate">
                            <div class="col-lg-12 select_from">
                                <h6>Nueva contraseña*</h6>
                                <input type="email" class="post_select" name="email" v-model="newPassword">
                            </div>
                            <div class="col-lg-12 select_from">
                                <h6>Verificar contraseña*</h6>
                                <input type="email" class="post_select" name="email" v-model="verifyPassword">
                            </div>
                            <div class="col-12">
                                <div class="row">
                                    <div class="form-group col-6">
                                        <a class="crear-cuenta theme_btn btn" v-on:click="loginOpen = true; event.preventDefault();">Iniciar sesión</a>
                                    </div>
                                    <div class="form-group col-6">
                                        <button class="theme_btn btn float-right" v-on:click="updatePassword()">Guardar</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="col-lg-4 col-md-5 col-sm-12 form-login-gpi" v-if="loginOpen == false && verificationStep == 4">
                        <div class="col-12 py-3">
                            <h3>Recuperar contraseña</h3>
                        </div>
                        <form class="from_main" method="post" id="phpcontactform" novalidate="novalidate">
                            <div class="col-lg-12 select_from">
                                <div class="alert alert-info">
                                    <strong>Exito</strong><br>
                                    Tu contraseña se ha reestablecido exitosamente, ahora sólo inicia sesión con tus nuevas credenciales.
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="row">
                                    <div class="form-group col-6 offse-3">
                                        <a class="crear-cuenta theme_btn btn" v-on:click="loginOpen = true; event.preventDefault();">Iniciar sesión</a>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="col-12">
                        <ol class="breadcrumb">
                            <li></li>
                            <li></li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- Banner Area -->

    <!-- Potential Area -->
    <section class="potential_area poa_2 vinculo-preaprobacion">
        <div class="container">
            <div class="tittle">
                <h2>Te ayudamos a cumplir tus sueños <span>y de los tuyos</span></h2>
                <p>Desde 1994 otorgamos servicios financieros con el mejor servicio a nivel nacional.<br> Buscamos la excelencia para posicionarnos como una empresa líder en el mercado automotriz</p>
            </div>
        </div>
    </section>
    <!-- Potential Area -->
  </div>
</template>

<script>
  export default {
    name: 'Login',
    data() {
      return {
        email: '',
        password: '',
        recoveryEmail: '',
        recoveryCode: '',
        newPassword: '',
        verifyPassword: '',
        verificationStep: 1,
        loginOpen: true,
        isLogin: true,
      }
    },
    methods: {
      login() {
        event.preventDefault();

        const data = {
          email: this.email,
          password: this.password
        };
        this.$SessionService.login(data).then((result) => {
          localStorage.setItem('session', result.data.session);
          localStorage.setItem('id', result.data.id);
          localStorage.setItem('tipo', result.data.tipo);
          location.reload();
        }, (err) => alert(err.msg));
      },
      sendRecoverPassword() {
        event.preventDefault();

        const data = {
          email: this.recoveryEmail
        };

        this.$SessionService.recoverPassword(data).then((result) => {
          this.verificationStep = 2;
        }, (err) => alert(err.msg));
      },
      validateRecoveryCode() {
        event.preventDefault();

        const data = {
          email: this.recoveryEmail,
          recoveryCode: this.recoveryCode
        };

        this.$SessionService.validateRecoveryCode(data).then((result) => {
          this.verificationStep = 3;
        }, (err) => alert(err.msg));
      },
      updatePassword() {
        event.preventDefault();

        if (this.newPassword != '' && this.verifyPassword != '') {
            if (this.newPassword.length >= 8 && this.verifyPassword.length >= 8) {
                if (this.newPassword == this.verifyPassword) {
                    const data = {
                    email: this.recoveryEmail,
                    recoveryCode: this.recoveryCode,
                    password: this.newPassword
                    };

                    this.$SessionService.updatePassword(data).then((result) => {
                    this.verificationStep = 4;
                    }, (err) => alert(err.msg));
                } else
                    alert('El campo de verificar contraseña es diferente de contraseña');
            } else
                alert('La contraseña debe contener al menos 8 carácteres');
        } else {
            alert('Por favor llene los campos de contraseña y verificar contraseña');
        }
      }
    },
    created() {
      localStorage.removeItem('quote_credit');
    }
  }
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/views/Login.vue